








































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import FooterButton from "@/components/FooterButton.vue";
import { AppData, CareGiver} from "@/models/app-data";
import { required, email, requiredIf, maxLength } from "vuelidate/lib/validators";
import CommonMixin, { WORKFLOW_PREFERRED_GREAT_START, WORKFLOW_PREFERRED_HEAD_START, WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { FinalDetailsEligibilityContent } from "@/models/content/final-details-eligibility";
import { CommonFormService } from "../service/common-form.service";
import { CommonFormBuilder } from "@/utils/common-form-builder";
import VueRecaptcha from "vue-recaptcha";

@Component({
    components: {
        FooterButton,
        VueRecaptcha,
    },
    validations: {
        followupRadio: {
            required
        },
        termsCheck: {
            checked: (value) => value === true
        },
        lastName: {
            required: requiredIf(function(this: FinalDetailsEligibility) {
                return this.needContactInfo();
            }),
            maxLength: maxLength(30)
        },
        firstName: {
            required: requiredIf(function(this: FinalDetailsEligibility) {
                return this.needContactInfo();
            }),
            maxLength: maxLength(30)
        },
        phoneNumber: {
            required: requiredIf(function(this: FinalDetailsEligibility) {
                return this.needContactInfo() && !this.email;
            }),
            validPhone: function(value: string) {
                if (!value) return true;
                // Allow formats: 123-456-7890 or (123) 456-7890
                const regex = /^(\d{3}-\d{3}-\d{4}|\(\d{3}\) \d{3}-\d{4})$/;
                return regex.test(value);
            }
        },
        email: {
            email,
            required: requiredIf(function(this: FinalDetailsEligibility) {
                return this.needContactInfo() && !this.phoneNumber;
            })
        },
        confirmEmailOrPhone: {
            hasOne: function(this: FinalDetailsEligibility) {
                if (!this.needContactInfo()) return true;
                return Boolean(this.email) || Boolean(this.phoneNumber);
            }
        }
    },
})
export default class FinalDetailsEligibility extends Mixins(CommonMixin) {
    commonFormService = new CommonFormService();
    commonFormBuilder = new CommonFormBuilder();
    content = {} as FinalDetailsEligibilityContent;
    appData = {} as AppData;
    followupRadio = false;
    ready4kRadio = false;
    termsCheck = false;
    PercentDone = 100;
    lastName = "";
    firstName = "";
    phoneNumber = "";
    email = "";
    IsSaving = false;
    textDirection = "ltr";
    language!: string;


    async mounted(): Promise<void> {
        try {
            const contentService = new ContentService(this.$route);
            this.content = await contentService.getFinalDetailsEligibilityContent();
            this.textDirection = contentService.TextDirection();
            this.language = contentService.Language();

            this.appData = this.getAppData();
            if (this.appData != null) {
                this.followupRadio = this.appData.followUp211 ?? false;
                if (this.appData.careGiver != null) {
                    this.lastName = this.appData.careGiver.lastName;
                    this.firstName = this.appData.careGiver.firstName;
                    this.phoneNumber = this.appData.careGiver.phoneNumber;
                    this.email = this.appData.careGiver.email;
                }
                this.putWorkflowStep(this.appData.workflowId, "FinalDetailsEligibility")
            }
        } catch (error) {
            this.showError(error instanceof Error ? error.message : String(error));
        }
        // Reset validation state
        this.$v.$reset();
    }

    needContactInfo(): boolean {
        return this.followupRadio === true
    }

    disableNext(): boolean {
        return this.IsSaving === true || this.termsCheck === false;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get TheCapcha(): any {
        return this.$refs.captcharef;
    }

    public async onNextPage(): Promise<void> {
        // Trigger validation
        this.$v.$touch();
        
        // If form is invalid, show errors and return
        if (this.$v.$invalid) {
            return;
        }

        this.IsSaving = true;
        this.TheCapcha.execute();
    }

    public async save(captchaToken: string): Promise<void> {
        try {
            this.appData.signupReady4k = this.ready4kRadio;
            this.appData.followUp211 = this.followupRadio;
            this.appData.language = this.language;
            if (this.appData.careGiver == null) {
                this.appData.careGiver = {} as CareGiver;
            }
            this.appData.careGiver.firstName = this.firstName;
            this.appData.careGiver.lastName = this.lastName;
            this.appData.careGiver.phoneNumber = this.phoneNumber;
            this.appData.careGiver.email = this.email;
            this.setPreferredProgram();
            this.saveAppData(this.appData);

            const commonForm = await this.commonFormBuilder.BuildCommonForm(
                this.appData,
                captchaToken
            );
            await this.startAndFinishCommonForm(commonForm);
        } catch (err) {
            this.showError(err instanceof Error ? err.message : String(err));
        } finally {
            this.IsSaving = false;
        }
    }

    private setPreferredProgram(): void {
        const redirect = this.$route?.query?.redirect;

        switch( redirect ) {
            case "/MatchGSRPLikelyReferral":
            case "/MatchGSRPReferral":
            case "/MatchNoneAndGSRPLikelyReferral":
            case "/MatchNoneAndGSRPReferral":
            case "/MatchNoneCDCLikelyAndGSRPReferral":
                this.appData.preferredProgram = WORKFLOW_PREFERRED_GREAT_START;
                break;

            case "/MatchHeadstartAndHSGSRPLikelyReferral":
            case "/MatchHSAndGSRPReferral":
            case "/MatchHSGSRPLikelyReferral":
                this.appData.preferredProgram = WORKFLOW_PREFERRED_HEAD_START_AND_GREAT_START;
                break;

            case "/MatchHeadstartReferral":
                this.appData.preferredProgram = WORKFLOW_PREFERRED_HEAD_START;
                break;
        }
    }

    async onVerifyCaptcha(captchaToken: string) {
        try {
            this.TheCapcha.reset();
            await this.save(captchaToken);
            this.handleNextPage();
        } catch (err) {
            this.showError("Could not save data");
        }
    }

    onExpiredCaptcha(): void {
        this.TheCapcha.reset();
    }

    onErrorCaptcha(): void {
        if (this.IsSaving === true) {
            this.IsSaving = false;
            this.showError("Captcha Error");
        }
    }


    public handleNextPage(): void {
        const redirect = this.$route?.query?.redirect;
        const path = Array.isArray(redirect) ? redirect[0] ?? '/' : redirect ?? '/';
        this.$router.push(path);
    }

    @Watch("phoneNumber")
    onPropertyChanged(value: string) {
        if (value != null) {
            // only allow numbers, (,), and -
            // this.phoneNumber = value.replace(/[^0-9]/g, '')
            // Once we have 10 numbers, format the number to (###) ###-####
            const numbersOnly = value.replace(/\D/g, "");
            if (numbersOnly.length == 10) {
                this.phoneNumber = numbersOnly
                    .replace(/[^0-9()-]/g, "")
                    .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            }
        }
    }

}
